import React from "react";

/**
 * Auto-expanding chip-row text input sized to its value or placeholder.
 *
 * @example
 * <SettingsChipInput
 *   value={draft}
 *   onChange={(event) => setDraft(event.target.value)}
 *   placeholder="+ Add sender…"
 * />
 */
const SettingsChipInput = ({
  value = "",
  placeholder = "+ Add…",
  className = "",
  ...inputProps
}) => {
  const sizerText = String(value || "").length > 0 ? value : placeholder;

  return (
    <span className={`settings-chip-input-wrap${className ? ` ${className}` : ""}`}>
      <span className="settings-chip-input-sizer" aria-hidden="true">
        {sizerText}
      </span>
      <input
        type="text"
        className="settings-chip-input"
        value={value}
        placeholder={placeholder}
        {...inputProps}
      />
    </span>
  );
};

export default SettingsChipInput;
